/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2025 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import { convertCase } from '@/utils/strings'
import { publicBucketBaseUrl } from '@/configs/env-vars'
import { defaultThumbnailUrl, iconUrlsByFileType, thumbnailUrlsByFileType } from '@/configs/urls'
import { normalizeValueArrayToString } from './general'
import { formatEmptyValue } from './assets'

const defaultColors = {
  validated: 'gray',
  creating: 'yellow',
  created: 'green',
  completed: 'green',
  failed: 'red',
  cancelled: 'red',
  completedWithFails: 'yellow'
}

const getFileTypeImageUrl = (extension, urls) => {
  const ext = extension.replace('.', '').toLowerCase()

  const fileTypes = {
    audio: ['mp3', 'wav', 'ogg', 'flac', 'aac', 'm4a', 'wma', 'opus', 'aiff'],
    video: ['mp4', 'avi', 'mkv', 'mov', 'wmv', 'flv', 'webm', 'mpeg', 'mpg', '3gp'],
    image: ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg', 'webp', 'ico', 'tiff', 'tif'],
    document: ['pdf', 'doc', 'docx', 'txt', 'rtf', 'odt', 'epub', 'pages']
  }

  for (const [type, extensions] of Object.entries(fileTypes)) {
    if (extensions.includes(ext)) {
      return urls[type]
    }
  }

  return urls.unknown
}

export const setPreviewUrl = (
  previewProp,
  extension,
  baseUri = publicBucketBaseUrl
) => {
  return previewProp
    ? `${baseUri}/${previewProp}`
    : extension
      ? getFileTypeImageUrl(extension, thumbnailUrlsByFileType)
      : defaultThumbnailUrl
}

export const generateStateTagConfig = (state, colors = defaultColors) => {
  const {
    camelCase,
    titleCase
  } = convertCase(state)

  return {
    label: titleCase,
    colorScheme: colors[camelCase]
  }
}

export const getFileTypeIconUrl = (extension) => {
  return getFileTypeImageUrl(extension, iconUrlsByFileType)
}

export const getBatchNames = ({
  containerValue,
  batchKey,
  batchNameKey
}) => {
  let batchNames

  if (Array.isArray(containerValue)) {
    const itemBatch = containerValue.map((object) => {
      const itemBatch = object[batchKey]

      return itemBatch ? itemBatch[batchNameKey] : null
    })
    batchNames = normalizeValueArrayToString(itemBatch.filter(Boolean))
  } else if (containerValue?.name) {
    batchNames = containerValue[batchNameKey]
  }

  return formatEmptyValue(batchNames)
}
